export const principalInformationStyles = {
  FormControl: {
    marginTop: "32px",
  },
  TextField: {
    marginTop: "24px",
  },
  FormControlSpecieContainer: {
    marginTop: "32px",
    marginRight: "10%",
    width: "40%",
    display: "flex",
  },
  AvailableCapacityTextField: {
    marginTop: "24px",
    width: "50%",
  },
  requiredFieldsHintContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    marginTop: "6px",
  },
  requiredFieldsHintText: {
    color: "#757575",
    fontSize: "0.75rem",
  },
};
